<template>
  <div class="base-layout">
    <!-- 通用头部 -->
    <header>
      <el-card shadow="never" class="base-layout-title">
        <slot name="header">
          <!-- 默认头部内容 -->
          <h1>{{ title }}</h1>
          <div class="header-actions">
            <slot name="header-actions"></slot>
          </div>
        </slot>
      </el-card>
    </header>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 通用搜索区域 -->
      <div class="search-area" v-if="showSearch">
        <el-card shadow="never">
          <div
            ref="searchFormDiv"
            :class="collapse ? 'collapse-true' : 'collapse-false'"
            class="collapse filter-form-container"
          >
            <slot name="search" />
          </div>
          <div class="search-actions">
            <div class="search-actions-left">
              <slot name="search-actions" />
            </div>
            <div class="search-actions-right">
              <el-tooltip class="item" effect="dark" content="展开/收起" placement="top-start">
                <el-icon
                  v-show="showCollapse"
                  :class="collapse ? 'rotated-down' : 'rotated-up'"
                  class="el-icon-arrow-up collapse-action rotated"
                  @click.native="handleCollapse"
                />
              </el-tooltip>
            </div>
          </div>
        </el-card>
      </div>

      <div>
        <el-card shadow="never">
          <slot name="table" class="base-layout-table" />
          <div class="pagination" v-if="showPagination">
            <slot name="pagination"></slot>
          </div>
        </el-card>
      </div>
    </main>

    <div>
      <slot name="dialog"></slot>
    </div>

    <div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseListLayout',
    props: {
      title: {
        type: String,
        default: '页面标题',
      },
      showSearch: {
        type: Boolean,
        default: true,
      },
      showPagination: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        collapse: false,
        showCollapse: false,
      };
    },
    mounted() {
      if (!this.$refs.searchFormDiv) {
        return false;
      }
      const height = this.$refs.searchFormDiv.offsetHeight;
      this.showCollapse = height > 150;
    },
    methods: {
      handleCollapse() {
        this.collapse = !this.collapse;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-layout {
    padding: 10px;
    height: 100%;
    &-title {
      margin-bottom: 10px;
      background: #fff;
      .el-card__body {
        padding: 10px;
      }
    }
  }

  .search-area {
    margin-bottom: 10px;
    .el-card__body {
      padding: 20px 20px;
    }
    .filter-form-container {
      max-height: 237px;
      overflow: hidden;
    }
    .search-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-left {
        display: flex;
        justify-content: flex-start;
      }
    }

    .collapse {
      transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      &-true {
        max-height: 135px;
        overflow: hidden;
      }

      &-false {
        max-height: 1000px;
      }

      &-action {
        cursor: pointer;
        font-size: 20px;
      }
      &-action:hover {
        color: #409eff;
      }
    }
  }

  .main-content {
    border-radius: 4px;
  }

  .pagination {
    margin-top: 20px;
    display: flex;
  }
</style>
